"use client"

import { useState, useEffect } from "react"

export function usePasswordCheck() {
  const [unlockedLessons, setUnlockedLessons] = useState(new Set())
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [subscriptionStatus, setSubscriptionStatus] = useState<string | null>(null)
  const [isAdmin, setIsAdmin] = useState(false)
  // "signed in at all" (has a portal session), regardless of whether the
  // subscription grants lesson access - that's `isAuthenticated`. The nav
  // uses signedIn + username to greet the user.
  const [signedIn, setSignedIn] = useState(false)
  const [username, setUsername] = useState<string | null>(null)

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch("/portal/api/check-auth.php", {
          credentials: "include", // Important: sends session cookies
        })
        const data = await response.json()

        setIsAdmin(!!data.isAdmin)
        setSignedIn(!!data.authenticated)
        setUsername(data.username ?? null)

        if (data.hasAccess) {
          setIsAuthenticated(true)
          const stored = localStorage.getItem("techtok-unlocked-lessons")
          if (stored) {
            setUnlockedLessons(new Set(JSON.parse(stored)))
          }
        } else {
          setIsAuthenticated(false)
        }

        setSubscriptionStatus(data.subscriptionStatus || null)
      } catch (error) {
        console.error("usePasswordCheck - Failed to check authentication:", error)
      } finally {
        setIsLoading(false)
      }
    }

    checkAuth()
  }, [])

  const checkPassword = (password, lessonId) => {
    if (isAuthenticated) {
      const newUnlocked = new Set([...Array.from(unlockedLessons), lessonId])
      setUnlockedLessons(newUnlocked)
      localStorage.setItem("techtok-unlocked-lessons", JSON.stringify(Array.from(newUnlocked)))
      return true
    }

    window.location.href = "/portal/login.php"
    return false
  }

  const isLessonUnlocked = (lessonId) => {
    if (isAuthenticated) return true

    return unlockedLessons.has(lessonId)
  }

  return {
    checkPassword,
    isLessonUnlocked,
    isAuthenticated,
    isLoading,
    subscriptionStatus,
    isAdmin,
    signedIn,
    username,
  }
}
